
import { useDispatch, useSelector } from "react-redux"
import { selectTranslations } from "../../services/i18n/i18nSlice"

import super_admin_img from '../../components/Navigation/icons/super_admin.svg'

import { loadUserProfileData, selectUserData } from "../../features/User/userSlice"
import { Form, Tab, Tabs } from "react-bootstrap"
import { TENANT } from "../../config/constants"
import { fetchUser } from "../UsersScreen/UsersApi"
import { useEffect, useState } from "react"
import { setLoading } from "../../services/global/globalSlice"
import AddUserInput from "../UsersScreen/_components/AddUserInput"
import { fetchImpersonateUser } from "./SuperAdminApi"
import SubjectsManager from "./SubjectsManager"
import OfaSettingsManager from "./OfaSettingsManager"

export default function SuperAdminScreen() {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const [impersonatedUserData, setImpersonatedUserData] = useState(null)

    const userData = useSelector(selectUserData)

    const loadImpersonatedUser = async (user_id) => {
        if(user_id){
            dispatch(setLoading(true))
            const response = await fetchUser(user_id)
            if(response.success){
                setImpersonatedUserData(response.data)
                dispatch(setLoading(false))
            } else {
                dispatch(setLoading(false))
            }
        }
    }

    const impersonateUser = async (user) => {
        if(user){
            dispatch(setLoading(true))
            const response = await fetchImpersonateUser(TENANT,user.user_id)
            if(response.success){
                loadImpersonatedUser(user.user_id)
                dispatch(loadUserProfileData())
                dispatch(setLoading(false))
            } else {
                dispatch(setLoading(false))
            }
        }
    }

    const resetImpersonification = async () => {
        dispatch(setLoading(true))
        const response = await fetchImpersonateUser(TENANT,null)
        if(response.success){
            setImpersonatedUserData(null)
            dispatch(loadUserProfileData())
            dispatch(setLoading(false))
        } else {
            dispatch(setLoading(false))
        }
    }

    useEffect(()=>{
        if(userData?.impersonation_user_id_by_tenant && userData?.impersonation_user_id_by_tenant[TENANT])
            loadImpersonatedUser(userData?.impersonation_user_id_by_tenant[TENANT])
    },[userData?.impersonation_user_id_by_tenant])

    return(
        <div className="p-2">
            <div className="d-flex justify-content-between">
                <div className="page_title">
                    <img src={super_admin_img} alt=''/>
                    <h1>{t.super_admin.page_title}</h1>
                </div>
            </div>
            <Tabs
                defaultActiveKey="impersonate"
                id="noanim-tab-example"
                className="mt-3 mb-4"
            >
                <Tab eventKey="impersonate" title={t.super_admin.impersonate}>
                    <h3>{t.super_admin.current_user}:</h3>
                    {
                        impersonatedUserData ?
                        <div className="d-flex flex-wrap justify-content-start">
                            <Form.Group className="mb-3 col-5 me-3">
                                <Form.Label>ID</Form.Label>
                                <Form.Control className="auto-width" type="text" disabled value={impersonatedUserData?.user_id || '' }  />
                            </Form.Group>
                            <Form.Group className="mb-3 col-5 me-3">
                                <Form.Label>E-mail</Form.Label>
                                <Form.Control className="auto-width" type="text" disabled value={impersonatedUserData?.email || '' }  />
                            </Form.Group>
                            <Form.Group className="mb-3 col-5 me-3">
                                <Form.Label>Nome</Form.Label>
                                <Form.Control className="auto-width" type="text" disabled value={impersonatedUserData?.firstname || '' }  />
                            </Form.Group>
                            <Form.Group className="mb-3 col-5 me-3">
                                <Form.Label>Cognome</Form.Label>
                                <Form.Control className="auto-width" type="text" disabled value={impersonatedUserData?.lastname || '' }  />
                            </Form.Group>
                            <button  onClick={resetImpersonification}>Reset</button>
                        </div> :
                        <AddUserInput onAddUser={impersonateUser} tryOnAdmin={true}  label={t.super_admin.select_user}/>

                    }
                </Tab>
                <Tab eventKey="subjects" title={t.super_admin?.subjects || 'Subjects'}>
                    <SubjectsManager />
                </Tab>
                <Tab eventKey="ofa_settings" title={'OFA Settings'}>
                    <OfaSettingsManager />
                </Tab>
                
            </Tabs>
        </div>
    )
}